module.exports = __webpack_public_path__ + "static/media/5_fanout_to_multifiber_B_orange_square.4552f8d7.png";